// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"148cd59e","156":"148cd59e","181":"148cd59e","259":"148cd59e","732":"36971311","836":"148cd59e"}[chunkId] + ".chunk.css";
};